import React, { useMemo } from 'react'
import { getEnvVar } from '@mc/client-env'
import { SprigProvider } from '@mc/sprig'

interface SprigAppProviderProps {
  anonymousId?: string
  children: React.ReactNode
}

export const SprigAppProvider = ({
  anonymousId,
  children,
}: SprigAppProviderProps) => {
  const config = useMemo(
    () => ({
      environmentId: getEnvVar('EDUCATOR_SPRIG_KEY') as string,
      enableLogging: getEnvVar('LOG_SPRIG_CALLS') as boolean,
      logPrefix: 'educator',
    }),
    [],
  )

  const autoIdentify = useMemo(() => ({ anonymousId }), [anonymousId])

  return (
    <SprigProvider config={config} autoIdentify={autoIdentify}>
      {children}
    </SprigProvider>
  )
}
